import * as types from '../actions/action-types'

const initialState = {
  isOpen: false,
  vin: null,
  componentId: null,
  // Pins of componentId the user picked in a pinout. Empty when the modal is
  // opened for a whole component (e.g. from the harness view tooltip).
  pins: [],
}

const relatedDiagramsModalReducer = function (state = initialState, action) {
  switch (action.type) {
    case types.SET_RELATED_DIAGRAMS_MODAL:
      return Object.assign({}, state, {
        isOpen: true,
        vin: action.vin,
        componentId: action.componentId,
        pins: action.pins || [],
      })
    case types.UNSET_RELATED_DIAGRAMS_MODAL:
      return Object.assign({}, state, {
        ...initialState,
      })
    default:
      return state
  }
}

export default relatedDiagramsModalReducer
